import { produce } from 'immer';
import { LeadManagementState } from './interface';
import { Actions } from './action';
import { LeadManagementAction } from './enum';

export const initialState: LeadManagementState = {
    form: {
        firstName: '',
        lastName: '',
        email: '',
    },
    result: {
        status: false,
    },
};

const leadManagementReducer = (state = initialState, action: Actions) => {
    return produce(state, (draftState) => {
        switch (action.type) {
            case LeadManagementAction.SET_RESULT:
                draftState.result = action.result;
                break;
            case LeadManagementAction.SET_FORM:
                draftState.form = { ...draftState.form, ...action.form };
                break;
            case LeadManagementAction.SET_ERROR:
                draftState.error = action.error;
                break;
        }
    });
};

export default leadManagementReducer;
